export enum UserPermissions {
  User = 'user',
  Restore = 'restore',
}
